import React from "react";
import { useProductsContext } from "../context/Context";
import { socialLinks } from "../data";

const SocialItem = () => {
  const { CursorBig, CursorSmall } = useProductsContext();
  return (
    <>
      <div className="social__list">
        {socialLinks.map(({ icon, link }, index) => {
          return (
            <li className="social__item" key={index}>
              <a
                className="social__link"
                href={link}
                onMouseOver={CursorBig}
                onMouseOut={CursorSmall}
              >
                {icon}
              </a>
            </li>
          );
        })}
      </div>
    </>
  );
};

export default SocialItem;
